import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CrmServiceService } from '../../../../service/crm-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DbService } from 'src/app/services/db-service/db.service';
import { FormControl } from '@angular/forms';
import { Observable, of, catchError, switchMap, map } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { StorageKeys } from 'src/app/shared-module-files/simpo.constant';
import { PricingDetailsComponent } from 'src/app/shared-module-files/components/pricing-details/pricing-details.component';
import { StaffServiceService } from 'src/app/master-config-components/micro-apps/staff/service/staff-service.service';
import { StaffAccessServiceService } from '../../../../crm-config/staff-access/staff-access-service.service';
import { ActivatedRoute } from '@angular/router';
import { CrmLabel } from '../../../../crm-models';

@Component({
  selector: 'app-create-call',
  templateUrl: './create-call.component.html',
  styleUrls: ['./create-call.component.scss'],
  providers: [DatePipe]
})
export class CreateCallComponent {
  selectedLabelIds: string[] = [];
  selectedLabels: CrmLabel[] = [];

  constructor(
    public dialogRef: MatDialogRef<CreateCallComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private crmService: CrmServiceService,
    private snackbar: MatSnackBar,
    private dbService: DbService,
    private activate: ActivatedRoute,
    private staffService: StaffServiceService
  ) {

  }

  isAdmin: boolean = false
  async ngOnInit() {
    this.isAdmin = this.staffService.isStaffAdmin()
    this.getStudentList();
    this.getStaffListing();
    await this.getAllPipelines();
    this.activate.queryParams.subscribe((qp: any) => {
      if (qp != null) {
        this.getLeadDetails(qp.leadId);
      }
    })
    if ((this.data?.data?.leadName?.length || 0) > 0)
      this.selectedContact = this.data.data.leadName
    if (this.data?.data?.edit && this.data?.data?.type !== 'ACTIVITY') {
      this.callDetails = JSON.parse(JSON.stringify(this.data.data.data));

      this.callDetails.startDateTime = new Date(this.callDetails.startDateTime);
      this.getStartTime(this.callDetails.startDateTime);
      this.selectedLabelIds = [...(this.callDetails.labelIds || [])];
      this.selectedLabels = [...(this.callDetails.labels || [])];
    }
    if (this.data.data.type == 'ACTIVITY' && this.data.data.edit) {
      this.getCallsById()
    }

    if (this.data.data.edit && this.data.data.type === 'ALL_CALLS') {
      this.callDetails = JSON.parse(JSON.stringify(this.data.data.data));
      this.selectedContact = this.callDetails.leadName;
      this.selectedLabelIds = [...(this.callDetails.labelIds || [])];
      this.selectedLabels = [...(this.callDetails.labels || [])];
      this.getPipeLine(this.callDetails.pipeline.id);
    }


    if (this.data.data.leadId) {
      this.callDetails.leadId = this.data.data.leadId;
      this.callDetails.leadName = this.data.data.leadName
    }

    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '')),
    );
  }
  minDate: Date = new Date();
  selectedOption: string = "INDIVIDUAL";
  selectedContact = ""
  listPipelines: any[] = [];
  pipelineStages: any[] = [];
  selectedPipelineId: string = '';
  selectedStageId: string = '';
  pipelineSelected: boolean = false;
  callTypes = [
    { value: "OUT_BOUND", viewValue: "OutBound" },
    { value: "IN_BOUND", viewValue: "InBound" },
  ]
  staffList: any = [];

  myControl = new FormControl('');
  options: any[] = []
  filteredOptions: Observable<any> | undefined;

  openDropdown: 'participantType' | 'contact' | 'assignedTo' | 'startDate' | 'callType' | 'callStatus' | 'reminder' | 'callPurpose' | null = null;

  toggleDropdown(name: 'participantType' | 'assignedTo' | 'startDate' | 'callType' | 'callStatus' | 'reminder' | 'callPurpose'): void {
    this.openDropdown = this.openDropdown === name ? null : name;
  }

  openContactDropdown(): void {
    this.openDropdown = 'contact';
  }

  closeDropdowns(): void {
    this.openDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDropdownDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.field-dd')) {
      this.closeDropdowns();
    }
  }

  trackByOptionValue(_index: number, item: any): string {
    return item.value ?? item.id;
  }

  selectParticipantType(value: string): void {
    this.participantType = value;
    this.getContacts();
    this.closeDropdowns();
  }

  getParticipantTypeLabel(): string {
    return this.type.find(t => t.value === this.participantType)?.viewValue || 'Select';
  }

  selectAssignedTo(staff: any): void {
    if (staff) {
      this.callDetails.assignedTo = staff.id;
      this.callDetails.assignedName = staff.name;
    }
  }

  setCallVariant(value: string): void {
    this.callDetails.call_variant = value;
    this.changingStatus();
  }

  startDateAsDate: Date | null = null;
  minDateAsDate: Date | null = null;

  openCallStartPicker(): void {
    this.startDateAsDate = this.startDate;
    this.minDateAsDate = this.callDetails.call_variant === 'SCHEDULE' ? this.today : null;
    this.toggleDropdown('startDate');
  }

  getCallStartLabel(): string {
    if (!this.startDate) return 'DD/MM/YYYY, HH:MM';
    const datePart = this.startDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    const timePart = this.startDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    return `${datePart}, ${timePart}`;
  }

  onCallStartApplied(date: Date): void {
    this.startDate = date;
    const yyyy = date.getFullYear();
    const MM = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    const HH = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    this.callDetails.startDateTime = `${yyyy}-${MM}-${dd}T${HH}:${mm}:00`;
    this.closeDropdowns();
  }

  selectCallType(value: string): void {
    this.callDetails.callType = value;
    this.closeDropdowns();
  }

  getCallTypeLabel(): string {
    return this.callTypes.find(t => t.value === this.callDetails.callType)?.viewValue || 'Select';
  }

  selectCallStatus(value: string): void {
    this.callDetails.callStatus = value;
    this.closeDropdowns();
  }

  getCallStatusLabel(): string {
    return this.status.find(s => s.value === this.callDetails.callStatus)?.viewValue || 'Select';
  }

  selectReminder(value: number): void {
    this.callDetails.remainder = value;
    this.closeDropdowns();
  }

  getReminderLabel(): string {
    return this.hourReminder.find(r => r.value === this.callDetails.remainder)?.viewValue || 'Select';
  }

  selectCallPurpose(value: string): void {
    this.callDetails.callPurpose = value;
    this.closeDropdowns();
  }

  getCallPurposeLabel(): string {
    return this.callPurpose.find(p => p.value === this.callDetails.callPurpose)?.viewValue || 'Select';
  }

  get createDisabled(): boolean {
    const anyMissing = !this.startDate || !this.callDetails['leadNumber'] || !this.callDetails.title ||
      (this.data.data.type == 'ALL_CALLS' ? !this.participantType : false) ||
      this.callDetails.callPurpose === 'OTHERS';
    return anyMissing ? !this.callDetails.otherReason : false;
  }

  get editDisabled(): boolean {
    return !this.callDetails.startDateTime;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.personalInfo.name.toLowerCase().includes(filterValue));
  }

  callDetails: any = {
    // callId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    businessId: this.dbService.getBusinessId(),
    title: "",
    startDateTime: "",
    // callStartTime: "",
    call_variant: "LOG",
    callStatus: "SCHEDULED",
    callType: "OUT_BOUND",
    remainder: 0,
    callDuration: "",
    callPurpose: "DEMO",
    otherReason: "",
    description: "",
    leadId: "",
    leadName: "",
    createdById: localStorage.getItem(StorageKeys.STAFF_ID),
    createdByName: localStorage.getItem(StorageKeys.STAFF_NAME),
    createdTimeStamp: new Date(),
    updatedTimeStamp: new Date(),
    pipeline: {
      id: "",
      name: ""
    },
    pipelineStage: {
      id: "",
      name: ""
    },
  }

  hourReminder = [
    { value: 0, viewValue: 'No Reminder' },
    { value: 10, viewValue: '10 minutes Before' },
    { value: 20, viewValue: '20 minutes Before' },
    { value: 30, viewValue: '30 minutes Before' },
    { value: 40, viewValue: '40 minutes Before' },
    { value: 50, viewValue: '50 minutes Before' },
    { value: 60, viewValue: '1 hour Before' },
    { value: 120, viewValue: '2 hours Before' },
    { value: 180, viewValue: '3 hours Before' },
    { value: 240, viewValue: '4 hours Before' },
    { value: 1440, viewValue: '1 day Before' },
    { value: 2880, viewValue: '2 days Before' },
  ]
  status = [
    { value: "NEW", viewValue: "New" },
    // { value: "ANSWERED", viewValue: "Answered" },
    { value: "USER_REJECTED", viewValue: 'User Rejected' },
    { value: "NOT_ANSWERED", viewValue: "Not Answered" },
    { value: "SCHEDULED", viewValue: 'Scheduled' },
    { value: "FOLLOW_UP", viewValue: "Follow Up" },
    // { value: "NO_RESPONSE", viewValue: "Noresponse/Busy" },
    { value: "DO_NOT_CALL", viewValue: "Do not Call" },
    { value: "FAILED", viewValue: "Failed" },
    { value: "MISSED_CALL", viewValue: "Missed Call" },
    { value: "COMPLETED", viewValue: "Completed" },
  ]


  callPurpose = [
    { value: "DEMO", viewValue: "Demo" },
    { value: "PROJECT", viewValue: "Project" },
    { value: "DESK", viewValue: "Desk" },
    { value: "NEGOTIATION", viewValue: 'Negotiation' },
    { value: "ADMINISTRATIVE", viewValue: "Administrative" },
    { value: "PROSPECTING", viewValue: "Prospecting" },
    { value: "OTHERS", viewValue: "Others" },
  ]

  dateTimeFormat: string = 'YYYY-MM-DDTHH:mm';

  leadDetails: any;
  getLeadDetails(leadId: any) {
    if (!leadId)
      return;
    this.crmService.getLeadById(leadId).subscribe(
      {
        next: (response: any) => {
          this.leadDetails = response.data;
          this.callDetails.pipeline = this.leadDetails.pipeline;
          this.callDetails.pipelineStage = this.leadDetails.pipelineStage;

          if ((this.data.data.type == 'CALLS' || this.data.data.type == 'ACTIVITY' || this.data.data.type == 'ALL_CALLS') && !this.data.data.edit) {
            this.callDetails.leadName = this.leadDetails.personalInfo.name;
            this.callDetails.leadId = this.leadDetails.id;
            this.callDetails.leadNumber = this.leadDetails.personalInfo.mobile;
          }

          // 🟢 Case 2: Create from Lead Detail Page
          let prefillPipelineId = '';
          let prefillStageId = '';
          if (this.selectedContact) {
            const leadDetails = this.leadDetails;
            prefillPipelineId = leadDetails?.pipeline?.id || '';
            prefillStageId = leadDetails?.pipelineStage?.id || '';
          }
          // ⚪ Case 3: Create directly from module
          else {
            prefillPipelineId = '';
            prefillStageId = '';
          }

          // --- Prefill pipeline and stage ---
          if (prefillPipelineId) {
            this.selectedPipelineId = prefillPipelineId;

            const selectedPipeline = this.listPipelines.find(
              (pipeline) => pipeline.id === this.selectedPipelineId
            );

            if (selectedPipeline) {
              this.pipelineStages = selectedPipeline.stages || [];
              this.pipelineSelected = true;

              if (prefillStageId) {
                this.selectedStageId = prefillStageId;
              }
            }
          } else {
            // Reset if none
            this.selectedPipelineId = '';
            this.selectedStageId = '';
            this.pipelineStages = [];
            this.pipelineSelected = false;
          }


          this.leadDetails.fieldMap = {};
          if (this.leadDetails.staffName && this.leadDetails.staffId) {
            const { staffName, staffId, pipeline } = this.leadDetails;
            this.filteredStaffList.push({ name: staffName, id: staffId });
            this.callDetails.assignedTo = staffId;
            const matchPipeline = this.listPipelines.find(p => p.id === pipeline?.id);
            if (matchPipeline?.assignedStaff) {
              const otherStaff = matchPipeline.assignedStaff
                .filter((staff: any) => staff.id !== staffId)
                .map((staff: any) => ({ name: staff.name, id: staff.id }));
              this.filteredStaffList.push(...otherStaff);
            }
            this.staffList = this.filteredStaffList;
          }
        },
        error: (err: any) => {
        }
      }
    )
  }
  getStartTime(date: any) {
    this.startDate = new Date(date);
  }

  transformedOptions: { id: string; fieldValue: string }[] = []; //
  getStudentList() {
    this.crmService.searchStudentList(this.dbService.getBusinessId(), this.selectedContact).subscribe(
      (res: any) => {
        this.options = res.data;
        this.transformedOptions = this.options
          .map(staff => {
            // Check if fieldData exists and has the required data
            const field = staff.fieldData.find(f => f.type === 'STUDENT_NAME');
            return field ? { id: staff.id, fieldValue: field.fieldValue } : null;
          })
          .filter((option): option is { id: string; fieldValue: string } => option !== null); // Type guard
      },
      (err) => {
        this.snackbar.open(`${err.error.message}`, 'Close', { duration: 1500 });
      }
    );
  }
  cancel() {
    this.dialogRef.close()
  }
  addLoader: boolean = false;
  startDate: Date | null = null;
  createLoader: boolean = false;
  createCall() {
    this.createLoader = true;
    if (!this.callDetails.assignedTo && !this.isAdmin) {
      this.callDetails.assignedTo = localStorage.getItem(StorageKeys.STAFF_ID) || '';
      this.callDetails.assignedName = localStorage.getItem(StorageKeys.STAFF_NAME) || '';
    }

    this.options.forEach(element => {
      if (this.callDetails.leadId == element.id) {
        this.callDetails.pipeline.id = element.pipeline.id;
        this.callDetails.pipeline.name = element.pipeline.name;
      }
    });

    this.crmService.createCall(this.callDetails).pipe(
      switchMap((res: any) => {
        const targetId = res?.data?.id || res?.data?.callId;
        return this.assignLabelsAfterSave(targetId, res).pipe(map((labelWarning) => labelWarning));
      })
    ).subscribe(
      (labelWarning: string | null) => {
        this.snackbar.open(
          labelWarning || `Call has been created successfully`,
          'Close',
          {
            duration: labelWarning ? 3500 : 1500
          }
        )
        this.dialogRef.close("success");
        this.addLoader = false;
      },
      (err) => {
        if (err.error.errorCode === 2000) {
          this.crmService.openSocialBrand(PricingDetailsComponent, '100vh', '100%', {})
        }
        this.createLoader = false
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        )
      }
    )
  }
  updateLoader: boolean = false;
  editCall() {
    this.updateLoader = true;

    this.options.forEach(element => {
      if (this.callDetails.leadId == element.id) {
        this.callDetails.pipeline.id = element.pipeline.id;
        this.callDetails.pipeline.name = element.pipeline.name;
      }
    });
    this.crmService.editCall(this.callDetails).pipe(
      switchMap((res: any) => {
        const targetId = res?.data?.id || this.callDetails?.id;
        return this.assignLabelsAfterSave(targetId, res).pipe(map((labelWarning) => labelWarning));
      })
    ).subscribe(
      (labelWarning: string | null) => {
        this.snackbar.open(
          labelWarning || `Call has been updated successfully`,
          'Close',
          {
            duration: labelWarning ? 3500 : 1500
          }
        )
        this.dialogRef.close()
        this.updateLoader = false;
      },
      (err) => {
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        )
      }
    )
  }

  participantType: any = "LEAD"
  type = [
    { value: "LEAD", viewValue: "Leads" },
    { value: "CUSTOMER", viewValue: "Customers" },
    { value: "PROSPECT", viewValue: "Prospects" }
  ]
  pageNo = 0;
  size = 100;
  getContacts() {
    this.crmService.searchLeadsCustomers(this.dbService.getBusinessId(), 0, 10, this.participantType, this.selectedContact).subscribe(
      (res: any) => {
        this.options = [];
        this.options = res.data.data;
        this.filteredOptions = this.myControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filter(value || '')),
        );
      },
      (err) => {
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          { duration: 1500 }
        )
      }
    )
  }
  searchContact() {
    if (this.selectedContact.length > 0) {
      this.options = this.options.filter(opt => opt.personalInfo.name.toLowerCase().includes(this.selectedContact.toLowerCase()) || opt.personalInfo.mobile.includes(this.selectedContact))
    }
    else {
      this.getContacts()
    }
  }
  contactSelected(contactData: any) {
    this.selectedContact = contactData.personalInfo.name;
    this.myControl.setValue(contactData.personalInfo.name, { emitEvent: false });
    this.callDetails.leadName = contactData.personalInfo.name;
    this.callDetails.leadId = contactData.id;
    this.callDetails.leadNumber = contactData.personalInfo.mobile
    if (contactData) {
      this.getPipeLine(contactData.pipeline.id);
    }
  }
  pipeLineName: string = '';
  getPipeLine(pipeLineId: any) {
    this.crmService.getPipeLineById(pipeLineId).subscribe((res: any) => {
      if (res.data) {
        this.pipeLineName = res.data.name
        this.filteredStaffList = res.data.assignedStaff || [];
        this.staffList = res.data.assignedStaff;
        if (this.data.data.edit) {
          this.callDetails.assignedTo = this.data?.data?.data?.assignedTo;
        }
      }
    })
  }
  getCallsById() {
    this.crmService.getCallDetails(this.data.data.callId).subscribe(
      (res: any) => {
        this.callDetails = res.data;
        this.getStartTime(this.callDetails.startDateTime);
        this.selectedLabelIds = [...(this.callDetails?.labelIds || [])];
        this.selectedLabels = [...(this.callDetails?.labels || [])];
      }
    )
  }

  onSelectedLabelIdsChange(ids: string[]): void {
    this.selectedLabelIds = [...(ids || [])];
  }

  onSelectedLabelsChange(labels: CrmLabel[]): void {
    this.selectedLabels = [...(labels || [])];
  }

  /** Returns null on success, or a human-readable warning string if labels could not be attached. */
  private assignLabelsAfterSave(targetId: string | undefined, rawResponse?: any): Observable<string | null> {
    if (!targetId) {
      if ((this.selectedLabelIds || []).length) {
        console.warn('Label assignment skipped: could not resolve target id from save response.', rawResponse);
        return of('Call saved, but labels could not be attached (missing call id). Please re-open and re-apply labels.');
      }
      return of(null);
    }
    const businessId = localStorage.getItem('businessId') || '';
    return this.crmService.assignLabels({
      businessId,
      targetType: 'CALL',
      targetId,
      labelIds: this.selectedLabelIds || []
    }).pipe(
      map(() => null),
      catchError((err) => {
        console.warn('Label assignment request failed.', err);
        return of(err?.error?.message || 'Call saved, but labels could not be updated');
      })
    );
  }

  changingStatus() {
    if (this.callDetails.call_variant === 'SCHEDULE' && this.startDate) {
      this.startDate = new Date();
    }

    this.callDetails.callDuration = null;
    this.callDetails.callType = "OUT_BOUND";
  }


  staffSearch: string = '';
  filteredStaffList: any[] = [];


  filterStaff() {
    if (this.staffSearch.length > 2)
      this.filteredStaffList = this.staffList.filter(staff => staff.name.includes(this.staffSearch))
    else if (this.staffSearch.length === 0)
      this.filteredStaffList = this.staffList
  }

  today: Date = new Date();

  getStaffListing() {
    this.staffService.getStaffListing(this.dbService.getBusinessId(), this.pageNo, this.size, '').subscribe({
      next: (res: any) => {
        this.staffList = res.data.data;
        this.filteredStaffList = this.staffList;

        if (this.filteredStaffList.length == 1) {
          this.callDetails.assignedTo = this.filteredStaffList[0].id;
          this.callDetails.assignedName = this.filteredStaffList[0].name;
        }

      },
      error: (err: any) => {
        this.snackbar.open(
          `${err.error.message}`,
          'Close',
          {
            duration: 1500
          }
        )
      }
    })
  }

  changeStaff() {
    for (let ele of this.staffList) {
      if (ele.id === this.callDetails.assignedTo) {
        // this.callDetails.assignToMailId = ele.contact.email;
        this.callDetails.assignedTo = ele.id;
        this.callDetails.assignedName = ele.name;
        break;
      }
    };
  }
  getAllPipelines() {
    const businessId = localStorage.getItem('businessId');
    const staffId = localStorage.getItem('staffId');

    this.crmService.getListPipelines(businessId, staffId, true).subscribe((res: any) => {
      this.listPipelines = res.data || [];

      let prefillPipelineId = '';
      let prefillStageId = '';

      // 🟢 Case 1: Edit mode
      if (this.data.data?.edit && this.callDetails?.pipeline?.id) {
        prefillPipelineId = this.callDetails.pipeline.id;
        prefillStageId = this.callDetails.pipelineStage?.id || '';
      }
    });
  }

  onPipelineChange() {
    const selectedPipeline = this.listPipelines.find(
      (pipeline) => pipeline.id === this.selectedPipelineId
    );

    if (selectedPipeline) {
      this.pipelineStages = selectedPipeline.stages || [];
      this.pipelineSelected = true;

      // Update call details
      this.callDetails.pipeline = {
        id: selectedPipeline.id,
        name: selectedPipeline.name
      };

      // Reset stage only if not editing
      if (!this.data.data?.edit) {
        this.selectedStageId = '';
        this.callDetails.pipelineStage = { id: '', name: '' };
      }
    }
  }

  onStageChange() {
    const selectedStage = this.pipelineStages.find(
      (stage) => stage.id === this.selectedStageId
    );

    if (selectedStage) {
      this.callDetails.pipelineStage = {
        id: selectedStage.id,
        name: selectedStage.name
      };
    }
  }
}
